const bathroom = `Kylpyhuoneen korjauspyyntö
Hei,
Toivon että voit hyvin
Minun täytyy kertoa sinulle asuntoni kylpyhuoneesta.
Hanat vuotavat, jotkut laatat ovat rikki ja hometta, mikä vaikeuttaa käyttöä.
Se aiheuttaa myös pahaa hajua asunnossa.
Voiko rakennusyhtiö korjata kylpyhuoneen? 
On tärkeää lopettaa nämä ongelmat ja tehdä asunnosta parempi kaikille.
Työ voi alkaa 15.11. ja päättyy 10.12.
Jos tarvitset lisätietoja tai haluat keskustella tästä, voit soittaa minulle numeroon 555-555-5555 tai lähettää minulle sähköpostia osoitteeseen example@email.com.
Kiitos että kuuntelit. 
terveisin,`
export default bathroom;